module.exports = __webpack_public_path__ + "static/media/page_not_found.8c3eb08c.svg";